export const SERVICEENGINEER_REQUEST = 'SERVICEENGINEER_REQUEST';
export const SERVICEENGINEER_SUCCESS = 'SERVICEENGINEER_SUCCESS';
export const SERVICEENGINEER_FAILURE = 'SERVICEENGINEER_FAILURE';
